import { Alert } from "@mantine/core";
import { ApiError } from "../api";

interface Props {
  readonly error: unknown;
}

export function ErrorAlert({ error }: Props) {
  const message =
    error instanceof ApiError
      ? `${error.status.toString()} ${error.statusText} — ${error.url}`
      : error instanceof Error
        ? error.message
        : "unknown error";
  return (
    <Alert color="red" title="Request failed">
      {message}
    </Alert>
  );
}
